import { type Simplify } from "shared/types";

type InvertRecord<T extends Record<string, string | number>> = {
  [P in T[keyof T]]: {
    [K in keyof T]: T[K] extends P ? K : never;
  }[keyof T];
};

export const invertRecord = <T extends Record<string, string | number>>(
  obj: T
): Simplify<InvertRecord<T>> =>
  Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [value, key])
  ) as Simplify<InvertRecord<T>>;

export function isKeyOf<T extends object>(
  obj: T,
  key: PropertyKey
): key is keyof T {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

export function isValueOf<T extends Record<string, string | number>>(
  obj: T,
  value: string | number
): value is T[keyof T] {
  return Object.values(obj).includes(value);
}
